import React from 'react';
import { Plus, Minus } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const ActivityContactsSelector = ({
  contactIds,
  contacts,
  companyId,
  typsaOrgUnitId,
  onAdd,
  onRemove,
  onChange
}) => {
  // Filter contacts based on selected company or TYPSA unit
  // BUT always include already selected contacts
  const getFilteredContacts = () => {
    let filtered = [];
    
    if (typsaOrgUnitId) {
      filtered = contacts.filter(c => c.typsa_org_unit_id === typsaOrgUnitId);
    } else if (companyId) {
      filtered = contacts.filter(c => c.company_id === companyId);
    } else {
      filtered = contacts;
    }
    
    // Always include selected contacts even if they don't match the filter
    const selectedIds = contactIds.filter(id => id);
    const selectedContacts = contacts.filter(c => selectedIds.includes(c.id));
    
    // Merge and dedupe
    const allContacts = [...filtered];
    selectedContacts.forEach(sc => {
      if (!allContacts.find(c => c.id === sc.id)) {
        allContacts.push(sc);
      }
    });
    
    return allContacts;
  };

  const filteredContacts = getFilteredContacts();

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>Contactos</Label>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onAdd}
          data-testid="add-contact-btn"
        >
          <Plus className="w-4 h-4" />
        </Button>
      </div>
      
      {contactIds.map((contactId, idx) => (
        <div key={idx} className="flex items-center gap-2">
          <Select
            value={contactId || "none"}
            onValueChange={(value) => onChange(idx, value === "none" ? '' : value)}
          >
            <SelectTrigger data-testid={`contact-select-${idx}`}>
              <SelectValue placeholder="Seleccionar contacto..." />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="none">-- Seleccionar --</SelectItem>
              {filteredContacts.map((contact) => (
                <SelectItem key={contact.id} value={contact.id}>
                  {contact.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          {contactIds.length > 1 && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => onRemove(idx)}
              data-testid={`remove-contact-${idx}`}
            >
              <Minus className="w-4 h-4 text-red-500" />
            </Button>
          )}
        </div>
      ))}
      
      {filteredContacts.length === 0 && (
        <p className="text-xs text-muted-foreground">
          No hay contactos asociados a esta empresa/unidad
        </p>
      )}
    </div>
  );
};

export default ActivityContactsSelector;
